import request from '@/utils/request'

/**
 * 获取成员信息
 * @param data
 * @returns {*}
 */
export function getContactsInfo(data) {
  return request.post('/phalapi/public/?service=App.Contacts.Info', data)
}
